import { render, staticRenderFns } from "./booking-event-report-incident-modal.vue?vue&type=template&id=15541710&scoped=true&"
import script from "./booking-event-report-incident-modal.vue?vue&type=script&lang=ts&"
export * from "./booking-event-report-incident-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15541710",
  null
  
)

export default component.exports